module.exports = {"userPoolId":"ap-southeast-2_86UHUeiBr","clientID":"1qf5mksp3u1fn20sop470odcui","regionName":"ap-southeast-2","accessKeyId":"AKIA5PIDJAVEZHMR7IEB","secretAccessKey":"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","identityPoolId":"ap-southeast-2:194ba2f5-64be-47a2-8bc8-4190773118cf","bucketName":"symbiotic-heartbeat-v2","host":"a24zcer962yu5i-ats.iot.ap-southeast-2.amazonaws.com"}


//////////////////
// WEBPACK FOOTER
// ../config/credentials_to_use.json
// module id = 1146
// module chunks = 28